import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'cookieConsent';

const getStoredConsent = () => {
    try {
        const v = localStorage.getItem(STORAGE_KEY);
        return v ? JSON.parse(v) : null;
    } catch {
        return null;
    }
};

const saveConsent = (consent) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...consent, timestamp: Date.now() }));
};

export const hasConsent = (type) => {
    const c = getStoredConsent();
    if (!c) return false;
    if (type === 'necessary') return true;
    return Boolean(c[type]);
};

const CookieConsent = () => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const [openPrefs, setOpenPrefs] = useState(false);
    const [analytics, setAnalytics] = useState(false);
    const [marketing, setMarketing] = useState(false);

    useEffect(() => {
        const stored = getStoredConsent();
        if (!stored) setVisible(true);
        else {
            setAnalytics(!!stored.analytics);
            setMarketing(!!stored.marketing);
        }
    }, []);

    const acceptAll = () => {
        saveConsent({ necessary: true, analytics: true, marketing: true });
        setVisible(false);
        setOpenPrefs(false);
    };

    const rejectAll = () => {
        saveConsent({ necessary: true, analytics: false, marketing: false });
        setVisible(false);
        setOpenPrefs(false);
    };

    const savePrefs = () => {
        saveConsent({ necessary: true, analytics, marketing });
        setVisible(false);
        setOpenPrefs(false);
    };

    if (!visible) return null;

    return (
        <div className="fixed inset-x-0 bottom-0 z-50 p-4">
            <div className="max-w-5xl mx-auto bg-white border border-gray-200 rounded-2xl shadow-xl p-4 sm:p-6">
                {!openPrefs ? (
                    <div className="flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between">
                        <p className="text-gray-700 text-sm sm:text-base">
                            {t('legal.cookies.sections.bannerMessage')}
                        </p>
                        <div className="flex gap-2 sm:gap-3">
                            <button onClick={rejectAll} className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50">
                                {t('legal.cookies.sections.bannerReject')}
                            </button>
                            <button onClick={() => setOpenPrefs(true)} className="px-4 py-2 rounded-lg border border-primary-200 text-primary-700 hover:bg-primary-50">
                                {t('legal.cookies.sections.bannerConfigure')}
                            </button>
                            <button onClick={acceptAll} className="px-4 py-2 rounded-lg bg-primary-600 text-white hover:bg-primary-700">
                                {t('legal.cookies.sections.bannerAccept')}
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold text-gray-900">{t('legal.cookies.sections.bannerTitle')}</h3>
                        <div className="space-y-2">
                            <label className="flex items-center gap-3">
                                <input type="checkbox" checked disabled />
                                <span className="text-gray-700">{t('legal.cookies.sections.bannerNecessary')}</span>
                            </label>
                            <label className="flex items-center gap-3">
                                <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} />
                                <span className="text-gray-700">{t('legal.cookies.sections.bannerAnalytics')}</span>
                            </label>
                            <label className="flex items-center gap-3">
                                <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} />
                                <span className="text-gray-700">{t('legal.cookies.sections.bannerMarketing')}</span>
                            </label>
                        </div>
                        <div className="flex gap-2 sm:gap-3">
                            <button onClick={rejectAll} className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50">
                                {t('legal.cookies.sections.bannerReject')}
                            </button>
                            <button onClick={savePrefs} className="px-4 py-2 rounded-lg bg-primary-600 text-white hover:bg-primary-700">
                                {t('legal.cookies.sections.bannerSave')}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CookieConsent;


